const formatStamp = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const isImageValue = (value) => {
  const raw = String(value || "");
  return (
    raw.startsWith("data:image") ||
    raw.startsWith("http://") ||
    raw.startsWith("https://") ||
    raw.startsWith("blob:")
  );
};

const ClientConfirmationPanel = ({
  flagged,
  phoneNumber,
  styles,
  verifiedAtFallback,
  visit,
}) => {
  const status = visit?.confirmationStatus || visit?.confirmation_status || "—";
  const isUnconfirmed = status === "Unconfirmed";
  const methodKey = String(visit?.method_status || "").toLowerCase();
  const isMemberCard = methodKey === "member_card";
  const methodLabel =
    visit?.confirmation_method ||
    visit?.verificationMethodLabel ||
    (isMemberCard ? "TeleTrace Member Card" : methodKey ? methodKey : "—");
  const cardId = visit?.member_card_reference || "—";
  const verifiedAt = formatStamp(
    visit?.confirmation_timestamp || verifiedAtFallback
  );
  const signedAt = formatStamp(
    visit?.signature_timestamp || visit?.confirmation_timestamp || verifiedAtFallback
  );
  const signature = visit?.signature || "";
  const bannerClass =
    flagged && isUnconfirmed
      ? styles.confirmationBannerWarning
      : styles.confirmationBanner;

  return (
    <div className={bannerClass}>
      <div className={styles.confirmationItem}>
        <span className={styles.confirmationLabel}>Status</span>
        <span
          className={`${styles.confirmationValue} ${
            isUnconfirmed ? styles.confirmationValueStrong || "" : ""
          }`.trim()}
        >
          {status}
        </span>
      </div>
      <div className={styles.confirmationItem}>
        <span className={styles.confirmationLabel}>Method</span>
        <span className={styles.confirmationValue}>
          {isUnconfirmed && !visit?.method_status ? "—" : methodLabel}
        </span>
      </div>
      {isMemberCard ? (
        <div className={styles.confirmationItem}>
          <span className={styles.confirmationLabel}>Card ID</span>
          <span className={styles.confirmationValue}>
            {isUnconfirmed ? "—" : cardId}
          </span>
        </div>
      ) : !isUnconfirmed ? (
        <div className={styles.confirmationItem}>
          <span className={styles.confirmationLabel}>Phone Number</span>
          <span className={styles.confirmationValue}>{phoneNumber || "—"}</span>
        </div>
      ) : null}
      <div className={styles.confirmationItem}>
        <span className={styles.confirmationLabel}>Verified At</span>
        <span className={styles.confirmationValue}>
          {isUnconfirmed ? "—" : verifiedAt}
        </span>
      </div>
      {isMemberCard && !isUnconfirmed ? (
        <>
          <div
            className={`${styles.confirmationItem} ${
              styles.confirmationSignatureItem || ""
            }`.trim()}
          >
            <span className={styles.confirmationLabel}>Client Signature</span>
            <div className={styles.confirmationSignatureBox}>
              {isImageValue(signature) ? (
                <img
                  alt="Client signature"
                  className={styles.confirmationSignatureImage}
                  src={signature}
                />
              ) : (
                <span className={styles.confirmationValue}>—</span>
              )}
            </div>
          </div>
          <div className={styles.confirmationItem}>
            <span className={styles.confirmationLabel}>Signed At</span>
            <span className={styles.confirmationValue}>
              {signedAt === "—" ? verifiedAt : signedAt}
            </span>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default ClientConfirmationPanel;
